module.exports = __webpack_public_path__ + "img/10_l_uk.929b2877.svg";